<template>
  <v-dialog
    v-model="dialog"
    max-width="800px"
    min-height="500px"
    :width="$vuetify.breakpoint.name == 'xs' ? '95%' : '60%'"
    style="z-index: 9999"
  >
    <v-card class="card pa-7 pt-16" style="z-index: 9999">
      <button @click="$emit('close')" class="close-btn">
        <v-icon>mdi-close</v-icon>
      </button>
      <h1 class="mt-16 mb-6" style="width: 100%">MEGA-FIND!</h1>
      <v-card-actions>
        <div style="width: 100%">
          <h2 class="mb-4">Congratulations, twitcher!</h2>

          <h2>
            You can now add 12 birds<br />
            to your bird life list.
          </h2>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "RewardCard",
  props: { dialog: Boolean },
};
</script>

<style scoped>
.card {
  color: white;
  border-radius: 30px;
  padding: 20px;
  min-height: 450px;
  border-radius: 20px !important;
  background-image: url("../assets/bg-reward.svg");
  background-size: cover;
}
.close-btn {
  position: absolute;
  right: 5%;
  top: 5%;
}
h1,
h2 {
  color: black;
  font-family: "MabryMedium";
}
h1 {
  font-style: normal;
  font-weight: normal;
  font-size: 32px;
  line-height: 43px;
  text-align: center;
  letter-spacing: 0.05em;

  color: #000000;
}
h2 {
  font-style: normal;
  font-weight: normal;
  font-size: 28px;
  line-height: 34px;
  width: 80%;
  margin: auto;

  text-align: center;
  letter-spacing: 0.05em;
}
</style>